import { render, staticRenderFns } from "./bindAccount.vue?vue&type=template&id=cf5c6ab8&scoped=true"
import script from "./bindAccount.vue?vue&type=script&lang=js"
export * from "./bindAccount.vue?vue&type=script&lang=js"
import style0 from "./bindAccount.vue?vue&type=style&index=0&id=cf5c6ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5c6ab8",
  null
  
)

export default component.exports